export default __webpack_public_path__ + "static/media/playstore.a96b46f2.svg";